var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategories = function SvgCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.5C5.776 1.5 6 1.724 6 2V4C6 4.276 5.776 4.5 5.5 4.5H4.5V5.5H7V5C7 4.724 7.224 4.5 7.5 4.5H10.5C10.776 4.5 11 4.724 11 5V7C11 7.276 10.776 7.5 10.5 7.5H7.5C7.224 7.5 7 7.276 7 7V6.5H4.5V9.5H7V9C7 8.724 7.224 8.5 7.5 8.5H10.5C10.776 8.5 11 8.724 11 9V11C11 11.276 10.776 11.5 10.5 11.5H7.5C7.224 11.5 7 11.276 7 11V10.5H4C3.724 10.5 3.5 10.276 3.5 10V4.5H2.5C2.224 4.5 2 4.276 2 4V2C2 1.724 2.224 1.5 2.5 1.5H5.5ZM10 9.5H8V10.5H10V9.5ZM10 5.5H8V6.5H10V5.5ZM5 2.5H3V3.5H5V2.5Z"
  })));
};
export default SvgCategories;